export const medicalreview = [
  { id: 1, name: "Primary", medicalTagids: [] },
  { id: 2, name: "Secondary", medicalTagids: [] },
  { id: 3, name: "Irrelevent", medicalTagids: [] },
];
